export default {
	state: {
		chavePrincipal: {}
	},
	getters: {
		"chavePrincipal": state => state.chavePrincipal
	},
	mutations: {
		setChavePrincipal(state, payload) {
			state.chavePrincipal = payload
		}
	},
	actions: {
		atualizarEstadoChavePrincipal({ commit }, payload) {
			commit('setChavePrincipal', payload)
		}
	}
};